import API from './index';

const api = {
 
    getSystemVariable() {
        return API.authAPI({
            url: '/system-variable',
            method: 'GET',
            params: {},
        });
    },
    updateSystemVariable({ id, data }) {
        return API.authAPI({
            url: `/system-variable/${id}`,
            method: 'PATCH',
            data,
        });
    },
    getNews() {
        return API.authAPI({
            url: '/news/get-news',
            method: 'GET',
            params: {},
        });
    },
    updateNews({ id, data }) {
        return API.authAPI({
            url: `/news/patch-news/${id}`,
            method: 'PATCH',
            data,
        });
    },
    getAllConfig() {
        return API.authAPI({
            url: '/system-variable/get-all-config',
            method: 'GET',
            params: {},
        });
    },
};
export default api;